import $ from 'jquery';
import { METRIC_NAMES, METRIC_TYPES, sendMetricsEvent } from 'app/statistics/metrics/metrics';

// Check for any uncaught exceptions globally
window.addEventListener('error', (event) => {
    const tags = {
        errorType: event.type,
        errorMessage: event.message,
        errorFileName: event.filename,
        errorLineNo: event.lineno,
        errorColNo: event.colno
    };

    sendMetricsEvent(METRIC_NAMES.CLIENT_ERROR, METRIC_TYPES.COUNTER, 1, tags);
});

// Handle uncaught rejections in async actions/promises globally
window.addEventListener('unhandledrejection', (event) => {
    const tags = {
        errorType: event.type,
        errorMessage: event.reason
    };

    sendMetricsEvent(METRIC_NAMES.CLIENT_ERROR, METRIC_TYPES.COUNTER, 1, tags);
});

// Handle jquery ajax errors globally, we care about timeouts
$(document).ajaxError((event, jqxhr, settings, thrownError) => {
    const isTimeout = thrownError === 'timeout';

    if (!isTimeout) {
        return;
    }

    const tags = {
        errorType: 'timeout',
        errorMessage: ''
    };

    sendMetricsEvent(METRIC_NAMES.CLIENT_ERROR, METRIC_TYPES.COUNTER, 1, tags);
});
